export default {
  Index: require('./Index.vue').default
}